import { precisionCopyMenuSectionOptionsSchema } from './schemas/precision_copy_menu_section_options_schema';

app.PrecisionCopyMenuSectionOptionsDetailsView = app.SchemaDetailsView.extend({
  initialize(options) {
    const schema = app.JsonHelper.deepClone(precisionCopyMenuSectionOptionsSchema);
    app.SchemaDetailsView.prototype.initialize.apply(this, [
      {
        title: 'Select attributes to copy over',
        subProperty: 'options',
        schema,
        callback: options.callback,
      },
    ]);
  },
});
